import { render, staticRenderFns } from "./VideoChatPage.vue?vue&type=template&id=70b2acbf&"
import script from "./VideoChatPage.vue?vue&type=script&lang=js&"
export * from "./VideoChatPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoChatPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports